import { render } from "./ShareModal.vue?vue&type=template&id=4d6dc6af&ts=true&lang=pug"
import script from "./ShareModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShareModal.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/home/kryltcov/WebstormProjects/sa_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__